<template>
    <!-- Only the field's own options can be added: the server refuses anything
         else, so offering free typing would only promise a value it will not keep. -->
    <b-taginput
        :model-value="entries"
        :data="remaining"
        autocomplete
        open-on-focus
        append-to-body
        :allow-new="false"
        :placeholder="entries.length ? '' : placeholder || $t('Select one or more')"
        @typing="text => (typed = text)"
        @update:model-value="values => emit('update:modelValue', values)"
    />
</template>

<script setup>
import { computed, ref } from 'vue';
import { choiceEntries, choiceOptions } from '@/utils/choiceEntries';

const props = defineProps({
    modelValue: { type: [Array, String], default: null },
    options: { type: Array, default: () => [] },
    placeholder: { type: String, default: '' }
});

const emit = defineEmits(['update:modelValue']);

const typed = ref('');

const entries = computed(() => choiceEntries(props.modelValue));

// What is left to pick, narrowed by what is being typed.
const remaining = computed(() => {
    const needle = typed.value.trim().toLowerCase();

    return choiceOptions(props.options).filter(
        option => !entries.value.includes(option) && (!needle || option.toLowerCase().includes(needle))
    );
});
</script>
